"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _DialogActions = _interopRequireDefault(require("@material-ui/core/DialogActions"));

var _excluded = ["children"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ModalActions = function ModalActions(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react.default.createElement(_DialogActions.default, rest, children);
};

var _default = ModalActions;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL01vZGFsL01vZGFsQWN0aW9ucy50c3giXSwibmFtZXMiOlsiTW9kYWxBY3Rpb25zIiwiY2hpbGRyZW4iLCJyZXN0Il0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7Ozs7Ozs7Ozs7OztBQUdBLElBQU1BLFlBQTBDLEdBQUcsU0FBN0NBLFlBQTZDO0FBQUEsTUFBR0MsUUFBSCxRQUFHQSxRQUFIO0FBQUEsTUFBZ0JDLElBQWhCOztBQUFBLHNCQUNqRCw2QkFBQyxzQkFBRCxFQUFtQkEsSUFBbkIsRUFBMEJELFFBQTFCLENBRGlEO0FBQUEsQ0FBbkQ7O2VBSWVELFkiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsgRGlhbG9nQWN0aW9ucywgRGlhbG9nQWN0aW9uc1Byb3BzIH0gZnJvbSAnQG1hdGVyaWFsLXVpL2NvcmUnO1xuXG5jb25zdCBNb2RhbEFjdGlvbnM6IFJlYWN0LkZDPERpYWxvZ0FjdGlvbnNQcm9wcz4gPSAoeyBjaGlsZHJlbiwgLi4ucmVzdCB9KSA9PiAoXG4gIDxEaWFsb2dBY3Rpb25zIHsuLi5yZXN0fT57Y2hpbGRyZW59PC9EaWFsb2dBY3Rpb25zPlxuKTtcblxuZXhwb3J0IGRlZmF1bHQgTW9kYWxBY3Rpb25zO1xuIl19